import { app } from 'app/app';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { MAIL_NEVER, MAIL_WEEKLY } from 'app/mailSubscriptionInterval';
import { TIME_SNACKBAR_MEDIUM } from 'app/timings';
import { AppController } from 'app/controller';
import { MasterLayout } from 'layout/master/main';
import { CompanyHeader } from 'module/companyHeader/main';
import { CompanyVideo } from 'module/companyVideo/main';
import { CompanyText } from 'module/companyText/main';
import { SubNavigation } from 'module/subNavigation/main';
import { JobCardList } from 'module/jobCardList/main';
import { BsCompanyRecruiterList } from 'module/bsCompanyRecruiterList/main';
import { Section } from 'module/section/main';
import { log } from '@karriereat/action-logger/dist/log';
import './styles.scss';

class BrandingSolutionJobs extends AppController {
    domBindings() {
        return {
            brandingSolution: '.c-brandingSolutionJobs',
            companyHeader: '.m-companyHeader',
            subNavigation: '.m-subNavigation',
            jobCardList: '.m-jobCardList',
            bsRelatedCompaniesList: '.m-bsRelatedCompaniesList',
            applicationVideo: '.c-brandingSolutionJobs__application .m-companyVideo',
            applicationVideoSection: '.c-brandingSolutionJobs__application .m-section',
            bsCompanyRecruiterListSection: '.c-brandingSolutionJobs__recruiterList',
            bsCompanyRecruiterList: '.c-brandingSolutionJobs__recruiterList .m-bsCompanyRecruiterList',
            requirementsVideo: '.c-brandingSolutionJobs__whatWeSearch .m-companyVideo',
            whatWeSearchText: '.c-brandingSolutionJobs__whatWeSearch .m-companyText',
            whatWeSearchSection: '.c-brandingSolutionJobs__whatWeSearch .m-section',
        };
    }

    getPropsFromDom() {
        return {
            slug: this.dom.brandingSolution.getAttribute('data-slug'),
            companyAlarmNotificationInterval:
                parseInt(this.dom.brandingSolution.getAttribute('data-companyalarmnotificationinterval'), 10),
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.companyHeader = new CompanyHeader(this.dom.companyHeader);

        if (this.dom.subNavigation) {
            this.subNavigation = new SubNavigation(this.dom.subNavigation);
        }
        if (this.dom.jobCardList) {
            this.jobCardList = new JobCardList(this.dom.jobCardList);
        }
        if (this.dom.bsCompanyRecruiterList) {
            this.bsCompanyRecruiterList = new BsCompanyRecruiterList(this.dom.bsCompanyRecruiterList);
        }
        if (this.dom.bsCompanyRecruiterListSection) {
            this.bsCompanyRecruiterListSection = new Section(this.dom.bsCompanyRecruiterListSection, [
                this.bsCompanyRecruiterList,
            ]);
        }
        if (this.dom.whatWeSearchText) {
            this.whatWeSearchText = new CompanyText(this.dom.whatWeSearchText);
        }
        if (this.dom.whatWeSearchSection && !this.dom.requirementsVideo) {
            this.whatWeSearchSection = new Section(this.dom.whatWeSearchSection, [this.whatWeSearchText]);
        }
    }

    subEvents() {
        if (this.bsCompanyRecruiterList) {
            this.bsCompanyRecruiterList.loadCaptcha();
        }
        this.initializeVideos();

        if (this.bsCompanyRecruiterList) {
            this.bsCompanyRecruiterList.events.on('addModalStyle', () => {
                this.layout.addModalStyle(true);
            });

            this.bsCompanyRecruiterList.events.on('removeModalStyle', () => {
                this.layout.removeModalStyle(true);
            });

            this.bsCompanyRecruiterList.events.on('showCompanyRecruiterInquiryToast', () => {
                this.layout.toast.updateProps({
                    active: true,
                    message: 'Deine Nachricht wurde erfolgreich gesendet!',
                    iconSuccess: true,
                    type: 'success',
                }, true);
                this.layout.toast.slideIn();
            });
        }
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true);
            });
            userCompanyFollow.events.on('onUnauthorized', (followObject) => {
                this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
            });
        } else {
            userCompanyFollow.events.on('onAddJob', () => {
                let snackbarText;
                if (this.props.companyAlarmNotificationInterval === MAIL_WEEKLY) {
                    snackbarText = 'Ab sofort erhältst du wöchentlich neue Jobs dieser Firma per E-Mail.';
                } else {
                    snackbarText = 'Ab sofort erhältst du täglich neue Jobs dieser Firma per E-Mail.';
                }

                this.layout.showSnackbar(
                    TIME_SNACKBAR_MEDIUM,
                    false,
                    false,
                    false,
                    false,
                    snackbarText,
                    false,
                    '/settings/notifications#c-notificationIndex-companyalarm',
                    false,
                    'Anpassen',
                );
            });
            userCompanyFollow.events.on('onRemoveJob', () => {
                if (this.props.companyAlarmNotificationInterval !== MAIL_NEVER) {
                    this.layout.showSnackbar(
                        TIME_SNACKBAR_MEDIUM,
                        false,
                        false,
                        false,
                        false,
                        'Du erhältst ab sofort keine Jobs dieser Firma mehr per E-Mail.',
                        true,
                        false,
                        false,
                        false,
                    );
                }
            });
            userCompanyFollow.events.on('onFollowError', (error) => {
                [].forEach.call(error.arguments[0].errors, (err) => {
                    if (err.meta.company_follow_max_limit) {
                        this.layout.showSnackbar(
                            TIME_SNACKBAR_MEDIUM,
                            false,
                            false,
                            false,
                            false,
                            'Oje, du hast das Maximum schon erreicht! '
                            + 'Um dieser Firma zu folgen, entfolge einer anderen Firma.',
                            false,
                            '/companyalarm?openAccordion=true',
                            false,
                            'Zum Firmen-Alarm ',
                        );
                    }
                });
            });
        }
    }

    initializeVideos() {
        if (this.dom.applicationVideo) {
            this.applicationVideo = new CompanyVideo(this.dom.applicationVideo);

            this.applicationVideo.events.on('play', () => {
                log('company-video-play', {
                    slug: this.props.slug,
                    type: 'application',
                });
            });
        }
        if (this.dom.applicationVideoSection) {
            this.applicationVideoSection = new Section(this.dom.applicationVideoSection, [this.applicationVideo]);
        }
        if (this.dom.requirementsVideo) {
            this.requirementsVideo = new CompanyVideo(this.dom.requirementsVideo);

            this.requirementsVideo.events.on('play', () => {
                log('company-video-play', {
                    slug: this.props.slug,
                    type: 'requirements',
                });
            });
        }
        if (this.dom.whatWeSearchSection && this.dom.requirementsVideo) {
            if (this.whatWeSearchText) {
                this.whatWeSearchSection = new Section(this.dom.whatWeSearchSection, [
                    this.requirementsVideo,
                    this.whatWeSearchText,
                ]);
            } else {
                this.whatWeSearchSection = new Section(this.dom.whatWeSearchSection, [this.requirementsVideo]);
            }
        }
    }
}

app.boot(BrandingSolutionJobs);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(BrandingSolutionJobs);
    });

    module.hot.accept(() => {});
}
